<!-- Matches the post-ARP-7119 production model: per-phase buttons always render
     during in-flight ops and are disabled with `disabledActionReason` as their
     tooltip rather than collapsing the row to a spinner. See
     application.component.html tab-bar-actions + disabledActionReason. -->
@if (flags.showSandboxSettings) {
  <button
    type="button"
    class="arpio-secondary-button"
    [disabled]="!!flags.disabledActionReason"
    [pTooltip]="flags.disabledActionReason"
    tooltipPosition="top"
  >
    SANDBOX SETTINGS
  </button>
}
@if (flags.showTestButton) {
  <button
    type="button"
    class="arpio-button"
    [disabled]="flags.testRecoverDisabled || !!flags.disabledActionReason"
    [pTooltip]="flags.disabledActionReason"
    tooltipPosition="top"
  >
    <span class="button-label">TEST</span>
  </button>
}
@if (flags.showRecoverButton) {
  <button
    type="button"
    class="arpio-danger-button"
    [disabled]="flags.testRecoverDisabled || !!flags.disabledActionReason"
    [pTooltip]="flags.disabledActionReason"
    tooltipPosition="top"
  >
    <span class="button-label">LAUNCH RECOVERY</span>
  </button>
}
@if (flags.showUnquarantine) {
  <button
    type="button"
    class="arpio-button"
    [disabled]="!!flags.disabledActionReason"
    [pTooltip]="flags.disabledActionReason"
    tooltipPosition="top"
  >
    UNQUARANTINE
  </button>
}
@if (flags.showFailback) {
  <button
    type="button"
    class="arpio-button"
    [disabled]="flags.failbackDisabled || !!flags.disabledActionReason"
    [pTooltip]="flags.disabledActionReason || (flags.failbackDisabled ? failbackNoResourcesTooltip : null)"
    tooltipPosition="top"
  >
    FAILBACK
  </button>
}
@if (flags.showConcludeRecovery) {
  <button
    type="button"
    class="arpio-danger-button"
    [disabled]="!!flags.disabledActionReason"
    [pTooltip]="flags.disabledActionReason"
    tooltipPosition="top"
  >
    CONCLUDE RECOVERY
  </button>
}
@if (flags.showConcludeTest) {
  <button
    type="button"
    class="arpio-button"
    [disabled]="!!flags.disabledActionReason"
    [pTooltip]="flags.disabledActionReason"
    tooltipPosition="top"
  >
    {{ flags.isEarlyStopTest ? 'CANCEL TEST' : 'CONCLUDE TEST' }}
  </button>
}
